module.exports = __webpack_public_path__ + "media/video.8466b9db.mp4";